import script from "./Qaa.vue?vue&type=script&lang=ts&setup=true"
export * from "./Qaa.vue?vue&type=script&lang=ts&setup=true"

import "./Qaa.vue?vue&type=style&index=0&id=2fef700c&lang=scss"

const __exports__ = script;

export default __exports__